import React, { useState } from 'react';
import {
	updatePrimaryColor,
	Popover,
	Icon,
	palette,
	Flex,
	Label,
	Input,
} from '@zeal/web-ui';
import {
	enableDevToolsForBranding,
	MOCK_DOMAIN_KEY,
} from '@app/Services/Branding/utils';

export const DevColorPicker = () => {
	const [domain, setDomain] = useState(
		localStorage.getItem(MOCK_DOMAIN_KEY) || ''
	);

	if (!enableDevToolsForBranding()) return null;

	return (
		<div
			style={{
				position: 'absolute',
				top: 10,
				right: 10,
				zIndex: 99999999,
			}}
		>
			<Popover>
				<Popover.Trigger
					style={{
						width: '30px',
						height: '30px',
						borderRadius: '100%',
						backgroundColor: palette.surface.primary.selected.pressed,
					}}
				>
					<Icon size="sm" iconName="userGear" variant="solid" color="white" />
				</Popover.Trigger>
				<Popover.Content>
					<Popover.Close></Popover.Close>
					<div className="p-6 ">
						<Flex isColumn gap="6">
							<Flex isColumn gap="2">
								<Label.Thin200>Primary Color</Label.Thin200>
								<input
									type="color"
									onChange={(e) => updatePrimaryColor(e.target.value)}
								/>
							</Flex>
							<Flex isColumn gap="2">
								<Input
									label="Mock Domain"
									type="text"
									placeholder="Enter mock domain"
									onChange={(e) => {
										setDomain(e.target.value);
										localStorage.setItem(MOCK_DOMAIN_KEY, e.target.value);
									}}
									value={domain}
								/>
							</Flex>
						</Flex>
					</div>
				</Popover.Content>
			</Popover>
		</div>
	);
};
